const translation = {
    details: 'פרטים',
    cards: 'כרטיסים'
}
export default translation